const PAYMENT_CALCULATOR_COMPONENT_TYPE = 'PaymentCalculator';
export default PAYMENT_CALCULATOR_COMPONENT_TYPE;
